import React from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import MassiveActionsSelectors from './MassiveActionsSelectors'

const MassiveActions = (props) => {
  const {
    actionOptions = [], onChangeAction, resultActionOptions = {}, limit,
    totalResult, checkResult, isAllSelected, onApplyMassAction,
    loadingMassiveAction, resetMassiveAction
  } = props

  return (
    <div className='containerActions'>
      <div className='containerDetails'>
        <div className='selectItemDescription'>
          <div><strong>{lang('dashboard_selected')}</strong></div>
          <div className='detailSelect'>
            {isAllSelected ? totalResult : checkResult?.length || 0} / {(isAllSelected || totalResult < limit ) ? totalResult : limit}
          </div>
        </div>
        <div className='selectItemDescription resultDescription'>
          <div><strong>{lang('dashboard_results')}</strong></div>
          <div className='detailSelect'>{totalResult}</div>
        </div>
      </div>
      {actionOptions.length > 0
        ? <MassiveActionsSelectors
          actionOptions={actionOptions}
          loadingMassiveAction={loadingMassiveAction}
          resetMassiveAction={resetMassiveAction}
          checkResult={checkResult}
          resultActionOptions={resultActionOptions}
          onChangeAction={onChangeAction}
          isAllSelected={isAllSelected}
          onApplyMassAction={onApplyMassAction}
        />
        : null
      }

    </div>
  )
}

export default MassiveActions
